import { createContext } from 'react';

export const errorContext = createContext([]);
export const ErrorContextProvider = errorContext.Provider;
export const ErrorContextConsumer = errorContext.Consumer;
